export default __webpack_public_path__ + "static/media/new-logo.56c0376c.png";